"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/modal/style");
var _modal = _interopRequireDefault(require("antd/lib/modal"));
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/divider/style");
var _divider = _interopRequireDefault(require("antd/lib/divider"));
require("antd/lib/select/style");
var _select = _interopRequireDefault(require("antd/lib/select"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _useModalState = require("../../../utils/useModalState");
var _usaStates = require("../../../utils/usaStates.utils");
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var UsaStates = _usaStates.UsaStatesUtils.UsaStates;
var ClinicianProviderPerStateEligibility = function ClinicianProviderPerStateEligibility(_ref) {
  var clinicianId = _ref.clinicianId,
    eligibility = _ref.eligibility,
    providerName = _ref.providerName,
    saveEligibleStates = _ref.saveEligibleStates,
    savingEligibileStates = _ref.savingEligibileStates,
    wrapperClassName = _ref.wrapperClassName;
  var modal = (0, _useModalState.useModalState)();
  var initialEligibileStates = (0, _react.useMemo)(function () {
    return (0, _lodash.map)(eligibility, 'state');
  }, [eligibility]);
  var _useState = (0, _react.useState)(initialEligibileStates),
    _useState2 = _slicedToArray(_useState, 2),
    formStates = _useState2[0],
    setFormStates = _useState2[1];
  (0, _react.useEffect)(function () {
    setFormStates(initialEligibileStates);
  }, [initialEligibileStates]);
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    saveEligibleStates(formStates);
  };
  var onCancel = function onCancel() {
    modal.hide();
  };
  var onReset = function onReset() {
    setFormStates(initialEligibileStates);
  };
  var onDeleteState = function onDeleteState(state) {
    setFormStates(function (formStates) {
      return (0, _lodash.reject)(formStates, function (formState) {
        return formState === state;
      });
    });
  };
  var onAddState = function onAddState(state) {
    setFormStates(function (formStates) {
      return [].concat(_toConsumableArray(formStates), [state]);
    });
  };
  var onChangeState = function onChangeState(prevState, newState) {
    setFormStates(function (formStates) {
      return (0, _lodash.map)(formStates, function (state) {
        return state === prevState ? newState : state;
      });
    });
  };
  if (!clinicianId) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('flex justify-between items-center', wrapperClassName)
  }, /*#__PURE__*/_react.default.createElement("div", null, (0, _lodash.isEmpty)(initialEligibileStates) ? "Not ".concat(providerName, " eligible") : /*#__PURE__*/_react.default.createElement("span", null, providerName, " eligible states: ", /*#__PURE__*/_react.default.createElement("strong", null, initialEligibileStates.join(', ')))), /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "default",
    onClick: modal.show
  }, "Configure")), /*#__PURE__*/_react.default.createElement(_modal.default, {
    title: "Clinician medication eligibility",
    visible: modal.visible,
    onCancel: onCancel,
    footer: /*#__PURE__*/_react.default.createElement("div", {
      className: "flex justify-around"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "ghost",
      onClick: onReset
    }, "Reset"), /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      disabled: (0, _lodash.isEqual)(initialEligibileStates, formStates),
      onClick: handleSubmit
    }, "Submit"))
  }, /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: savingEligibileStates
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, (0, _lodash.map)(formStates, function (formState) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "flex justify-between mb-[20px]",
      key: formState
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      showSearch: true,
      size: "large",
      className: "min-w-[300px]",
      value: formState,
      onChange: function onChange(newState) {
        return onChangeState(formState, newState);
      },
      filterOption: function filterOption(input, option) {
        return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }
    }, UsaStates.map(function (state) {
      return /*#__PURE__*/_react.default.createElement(_select.default.Option, {
        value: state.abbreviation,
        key: state.abbreviation
      }, state.name);
    })), /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: function onClick() {
        return onDeleteState(formState);
      },
      type: "link"
    }, "Delete"));
  })), !(0, _lodash.isEmpty)(formStates) && /*#__PURE__*/_react.default.createElement(_divider.default, null), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", null, "New state"), /*#__PURE__*/_react.default.createElement(_select.default, {
    showSearch: true,
    placeholder: "New State",
    size: "large",
    onChange: function onChange(state) {
      return onAddState(state);
    },
    value: null,
    className: "min-w-[300px]",
    filterOption: function filterOption(input, option) {
      return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }, UsaStates.map(function (state) {
    return /*#__PURE__*/_react.default.createElement(_select.default.Option, {
      value: state.abbreviation,
      key: state.abbreviation,
      disabled: formStates === null || formStates === void 0 ? void 0 : formStates.includes(state.abbreviation)
    }, state.name);
  })))))));
};
var _default = ClinicianProviderPerStateEligibility;
exports.default = _default;